export default {
  inbox: {
    title: 'Entrada',
    pending: 'Para tratar',
    treated: 'Tratados'
  },
  outbox: {
    title: 'Saída',
    pending: 'Para Enviar',
    sent: 'Enviadas',
    accepted: 'Aceites',
    rejected: 'Recusadas'
  },
  start: 'Início',
  search: 'Procurar',
  stored: 'Faturas Armazenadas',
  rioja: {
    queryProcedure: 'Ver data prevista de pagamento',
    queryThirdparty: 'Ver ficha de terceiro'
  }
}